
import { useAccountGetEntityInfoQuery } from '@vs/rtk/slices/apiVsAccount2';
import { PortalAvatarUserProfileCard } from '@vs/ui/portal/avatar-user-profile-card';
import { useTranslation } from 'react-i18next';

import entityDefaultAvatar from '../assets/entity-management.png';

export type PropsEntityInfoCard = { accountId: string };

export default function EntityInfoCard({ accountId }: PropsEntityInfoCard) {
  const { t } = useTranslation('shared');

  const { data: accountEntityInfo, error: entityInfoError } =
    useAccountGetEntityInfoQuery(
      {
        accountId,
      },
      { skip: !accountId }
    );

  if (!accountId || (entityInfoError && !accountEntityInfo)) {
    return null;
  }

  let entityName = '';
  let hasEntity = false;

  if (accountEntityInfo && !entityInfoError) {
    hasEntity = !!accountEntityInfo.data.id;
    if (hasEntity) {
      entityName = accountEntityInfo.data.name || '';
    }
  }

  if (!hasEntity) {
    return null;
  }

  return (
    <PortalAvatarUserProfileCard
      testIdName="default-entity"
      title={t('avatar_menu.entity')}
      textMain={entityName}
      logoUrl={entityDefaultAvatar}
      link={{
        href: '/entity',
        label: t('avatar_menu.label.manage_entity'),
      }}
    />
  );
}
